import { render } from "./TGSelect.vue?vue&type=template&id=66c2e19c&scoped=true&ts=true"
import script from "./TGSelect.vue?vue&type=script&lang=ts"
export * from "./TGSelect.vue?vue&type=script&lang=ts"

import "./TGSelect.vue?vue&type=style&index=0&id=66c2e19c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c2e19c"]])

export default __exports__